export interface IMaritalStatus {
  code: string;
  description: string;
}

export const MaritalStatus: IMaritalStatus[]= [
  {
    code: '1',
    description: 'Single'
  },
  {
    code: '2',
    description: 'Married'
  },
  {
    code: '3',
    description: 'Widowed'
  },
  {
    code: '5',
    description: 'Divorced'
  },
]